import React from 'react';
import Video from '@/modules/Video';
import { $t } from '@/modules/i18n';
import playerButton from '@succ/public/images/about/player-button.svg';

export default ({ message }) => {
  return (
    <div className="about-container">
      <div id="about" style={{ position: 'relative', top: '-120px' }}></div>
      <h2 className="about-title">{$t(message.title)}</h2>
      <Video message={message.video}>
        <img src={playerButton} className="player-button"/>
      </Video>
    </div>
  )
}